import themeCreator from '@Themes/themeCreator';

const customTheme = themeCreator();

const useChatBotStyles = () => ({
  paperProps: () => ({
    boxShadow: `0px ${customTheme.spacing(0.5)} ${customTheme.spacing(1)} rgba(0, 0, 0, 0.2)`, // Equivalent to 4px 8px
    pointerEvents: 'auto',
    margin: 0,
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    height: "100%",
    width: "100%",
    color: customTheme.palette.primary.main,
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      width: customTheme.spacing(0.5), // Equivalent to 4px
      height: customTheme.spacing(0.0625), // Equivalent to 0.5px
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent', // Initially transparent
      borderRadius: customTheme.spacing(0.5), // Equivalent to 4px
      transition: 'background-color 0.3s', // Smooth transition effect
    },
    '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
      backgroundColor: 'transparent', // Track remains transparent
    },
    '&:hover::-webkit-scrollbar-thumb, & *:hover::-webkit-scrollbar-thumb': {
      backgroundColor: '#9e9e9e', // Medium grey on hover
    },
  }),
  popupButton: {
    marginLeft: 0,
    marginRight: customTheme.spacing(1), // Equivalent to 8px
    fontSize: customTheme.typography.pxToRem(60), // Using pxToRem for font sizing
    borderRadius: '50%',
    padding: 0,
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
    position: 'fixed',
    bottom: "5.5%",
    right: "1%",
    boxShadow: `0px ${customTheme.spacing(0.5)} ${customTheme.spacing(1)} rgba(0, 0, 0, 0.2)`, // Equivalent to 4px 8px
  },
  popupContent: {
    padding: 0,
    flexGrow: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    position: 'relative',
  },
  popupHeaderIcons: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
  },
  closeButton: {
    cursor: 'pointer',
    position: 'absolute',
    right: customTheme.spacing(1.25), // Equivalent to 10px
    top: customTheme.spacing(1.75), // Equivalent to 14px
    color: 'grey',
  },
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', // Centers vertically

    // padding: customTheme.spacing(2), // Equivalent to 16px
    height: customTheme.spacing(6),
    backgroundColor: customTheme.palette.background.paper,
    border: `2px solid ${customTheme.palette.divider}`,
  },
  leftTab: {
    flex: 1,
    textAlign: "center",
    borderRight: `2px solid ${customTheme.palette.divider}`,
    height: "100%",
    paddingTop: "10px",
    cursor:"pointer",
    "&:hover": {
      backgroundColor: customTheme.palette.action.hover,
    },
  },
  rightTab:{
    flex: 1,
    textAlign: "center",
    height: "100%",
    paddingTop: "10px",
    cursor:"pointer",
    "&:hover": {
      backgroundColor: customTheme.palette.action.hover,
    },
  },
  isActiveTab: {
    backgroundColor: customTheme.palette.action.selected,
    color: customTheme.palette.primary.main,
  },
  isInactiveTab: {
    backgroundColor: customTheme.palette.background.paper,
    color: customTheme.palette.text.secondary,
  },
  theme: customTheme,
});

export default useChatBotStyles;
